import { render, staticRenderFns } from "./AppConfigurationDialog.vue?vue&type=template&id=51d372c2&scoped=true&"
import script from "./AppConfigurationDialog.vue?vue&type=script&lang=js&"
export * from "./AppConfigurationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigurationDialog.vue?vue&type=style&index=0&id=51d372c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d372c2",
  null
  
)

export default component.exports